import ActionMenuItem from "components/Shared/ActionMenuItem/ActionMenuItem";
import { Employee, UserPermissions } from "generated/graphql";
import Archive from "./Archive";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";

export default function MenuItems({
  id,
  closeMenu,
}: {
  id: Employee["id"];
  closeMenu: () => void;
}) {
  const { hasPermissions } = useCheckPermissions();
  if (!hasPermissions(UserPermissions.MANAGE_EMPLOYEES)) {
    return <></>;
  }
  return (
    <>
      <ActionMenuItem
        closeMenu={closeMenu}
        route={`/organization/employees/${id}/update`}
        text="Edit"
      />
      <Archive closeMenu={closeMenu} id={id} />
    </>
  );
}
